import { BaseRepositoryV2 } from "@/repositories/base-repository-v2";
import type {
  IReportsRepository,
  ProcessReportResponse,
  PushReportsPayload,
  PushReportsResponse,
  TStatus,
} from "./types";

export default class ReportsRepository extends BaseRepositoryV2 implements IReportsRepository {
  path: string;
  pushReports;
  getReports;
  constructor() {
    super();
    this.path = "reports";
    this.pushReports = async (payload: PushReportsPayload) => {
      const response = await this.post(this.path, payload, {}, true);
      return this.toAxiosResponse<PushReportsResponse>(response);
    };
    this.getReports = async (status: TStatus) => {
      const response = await this.get(`/process/${this.path}?status=${status}`, {}, true);
      return this.toAxiosResponse<ProcessReportResponse>(response);
    };
  }
}
